/*
 * © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React from 'react';
import { PROMETHEAN_PURPLE_GRAPE, PROMETHEAN_LIGHT_PURPLE, PROMETHEAN_NEUTRAL_DARK_GREY } from '../styles/colors/colors';
import { alpha } from '@mui/system';
export var fillIcon = /*#__PURE__*/React.createElement("svg", {
  role: "none",
  name: "fillIcon",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.5501 3.77872C11.7335 3.40709 12.2634 3.40709 12.4468 3.77872L14.9565 8.86385L20.5683 9.67928C20.9784 9.73888 21.1421 10.2429 20.8454 10.5321L16.7846 14.4904L17.7432 20.0795C17.8133 20.4879 17.3846 20.7994 17.0178 20.6065L11.9985 17.9677L6.97913 20.6065C6.61231 20.7994 6.1836 20.4879 6.25365 20.0795L7.21226 14.4904L3.15154 10.5321C2.85478 10.2429 3.01854 9.73888 3.42865 9.67928L9.04042 8.86385L11.5501 3.77872Z",
  fill: PROMETHEAN_PURPLE_GRAPE
}));
export var emptyIcon = /*#__PURE__*/React.createElement("svg", {
  role: "none",
  name: "emptyIcon",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.2924 9.77785L14.0597 9.30641L11.9985 5.12978L9.93716 9.30641L9.70449 9.77785L9.18422 9.85345L4.57503 10.5232L7.91027 13.7743L8.28674 14.1412L8.19787 14.6594L7.41052 19.25L11.5331 17.0826L11.9985 16.8379L12.4638 17.0826L16.5864 19.25L15.799 14.6594L15.7102 14.1412L16.0866 13.7743L19.4219 10.5232L14.8127 9.85345L14.2924 9.77785ZM9.04042 8.86385L3.42865 9.67928C3.01854 9.73888 2.85478 10.2429 3.15154 10.5321L7.21226 14.4904L6.25365 20.0795C6.1836 20.4879 6.61231 20.7994 6.97913 20.6065L11.9985 17.9677L17.0178 20.6065C17.3846 20.7994 17.8133 20.4879 17.7432 20.0795L16.7846 14.4904L20.8454 10.5321C21.1421 10.2429 20.9784 9.73888 20.5683 9.67928L14.9565 8.86385L12.4468 3.77872C12.2634 3.40709 11.7335 3.40709 11.5501 3.77872L9.04042 8.86385Z",
  fill: PROMETHEAN_PURPLE_GRAPE
}));
export var hoverIcon = /*#__PURE__*/React.createElement("svg", {
  role: "none",
  name: "hoverIcon",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.5501 3.77872C11.7335 3.40709 12.2634 3.40709 12.4468 3.77872L14.9565 8.86385L20.5683 9.67928C20.9784 9.73888 21.1421 10.2429 20.8454 10.5321L16.7846 14.4904L17.7432 20.0795C17.8133 20.4879 17.3846 20.7994 17.0178 20.6065L11.9985 17.9677L6.97913 20.6065C6.61231 20.7994 6.1836 20.4879 6.25365 20.0795L7.21226 14.4904L3.15154 10.5321C2.85478 10.2429 3.01854 9.73888 3.42865 9.67928L9.04042 8.86385L11.5501 3.77872Z",
  fill: alpha(PROMETHEAN_LIGHT_PURPLE, 0.4)
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.2924 9.77785L14.0597 9.30641L11.9985 5.12978L9.93716 9.30641L9.70449 9.77785L9.18422 9.85345L4.57503 10.5232L7.91027 13.7743L8.28674 14.1412L8.19787 14.6594L7.41052 19.25L11.5331 17.0826L11.9985 16.8379L12.4638 17.0826L16.5864 19.25L15.799 14.6594L15.7102 14.1412L16.0866 13.7743L19.4219 10.5232L14.8127 9.85345L14.2924 9.77785ZM9.04042 8.86385L3.42865 9.67928C3.01854 9.73888 2.85478 10.2429 3.15154 10.5321L7.21226 14.4904L6.25365 20.0795C6.1836 20.4879 6.61231 20.7994 6.97913 20.6065L11.9985 17.9677L17.0178 20.6065C17.3846 20.7994 17.8133 20.4879 17.7432 20.0795L16.7846 14.4904L20.8454 10.5321C21.1421 10.2429 20.9784 9.73888 20.5683 9.67928L14.9565 8.86385L12.4468 3.77872C12.2634 3.40709 11.7335 3.40709 11.5501 3.77872L9.04042 8.86385Z",
  fill: PROMETHEAN_PURPLE_GRAPE
}));
export var disabledFillIcon = /*#__PURE__*/React.createElement("svg", {
  role: "none",
  name: "disabledFillIcon",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.5501 3.77872C11.7335 3.40709 12.2634 3.40709 12.4468 3.77872L14.9565 8.86385L20.5683 9.67928C20.9784 9.73888 21.1421 10.2429 20.8454 10.5321L16.7846 14.4904L17.7432 20.0795C17.8133 20.4879 17.3846 20.7994 17.0178 20.6065L11.9985 17.9677L6.97913 20.6065C6.61231 20.7994 6.1836 20.4879 6.25365 20.0795L7.21226 14.4904L3.15154 10.5321C2.85478 10.2429 3.01854 9.73888 3.42865 9.67928L9.04042 8.86385L11.5501 3.77872Z",
  fill: PROMETHEAN_NEUTRAL_DARK_GREY
}));
export var disabledEmptyIcon = /*#__PURE__*/React.createElement("svg", {
  role: "none",
  name: "disabledEmptyIcon",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.2924 9.77785L14.0597 9.30641L11.9985 5.12978L9.93716 9.30641L9.70449 9.77785L9.18422 9.85345L4.57503 10.5232L7.91027 13.7743L8.28674 14.1412L8.19787 14.6594L7.41052 19.25L11.5331 17.0826L11.9985 16.8379L12.4638 17.0826L16.5864 19.25L15.799 14.6594L15.7102 14.1412L16.0866 13.7743L19.4219 10.5232L14.8127 9.85345L14.2924 9.77785ZM9.04042 8.86385L3.42865 9.67928C3.01854 9.73888 2.85478 10.2429 3.15154 10.5321L7.21226 14.4904L6.25365 20.0795C6.1836 20.4879 6.61231 20.7994 6.97913 20.6065L11.9985 17.9677L17.0178 20.6065C17.3846 20.7994 17.8133 20.4879 17.7432 20.0795L16.7846 14.4904L20.8454 10.5321C21.1421 10.2429 20.9784 9.73888 20.5683 9.67928L14.9565 8.86385L12.4468 3.77872C12.2634 3.40709 11.7335 3.40709 11.5501 3.77872L9.04042 8.86385Z",
  fill: PROMETHEAN_NEUTRAL_DARK_GREY
}));